/* eslint-disable no-console */
<template>
  <div class="real-time-page">
    <!-- 头部 -->
    <div class="head">
      <div class="head-left">
        <div class="time">
          {{ currentTime | getDate }}
          <span class="real_week">{{ currentTime | getWeeb }}</span>
          <span class="real_time"> {{ newTime }}</span>
        </div>
      </div>
      <div class="arrival_title">联帮帮数字物流服务平台</div>
      <div class="head-right">
        <div class="right-big">
          <!-- <span @click="pagesBig">全屏</span> -->
          <!-- <img
            src="@/assets/arrival/big.png"
            @click="pagesBig"
            class="big-img"
            alt=""
          /> -->
          <div
            class="sel_time"
            :class="{ is_sel_time: selSearchNum === 365 }"
            @click="selSearch(365)"
          >
            全年
          </div>
          <div
            class="sel_time"
            :class="{ is_sel_time: selSearchNum === 30 }"
            @click="selSearch(30)"
          >
            30天
          </div>
          <div
            class="sel_time"
            :class="{ is_sel_time: selSearchNum === 7 }"
            @click="selSearch(7)"
          >
            7天
          </div>
          <div
            class="sel_time"
            :class="{ is_sel_time: selSearchNum === 1 }"
            @click="selSearch(1)"
          >
            今日
          </div>
        </div>
      </div>
    </div>
    <!-- 车辆信息 -->
    <div class="car-number">
      <div
        class="each-exhibition"
        :class="{ 'sel-exhibition': topType == 1 }"
        @click="selType(1)"
      >
        <div class="exhibition-top">
          <div class="top-right">
            <div class="right-number number_one">
              {{ trainNumber.cnt || "0" }}
            </div>
            <div class="right-title">总车次</div>
          </div>
        </div>
      </div>
      <div
        class="each-exhibition"
        :class="{ 'sel-exhibition': topType == 2 }"
        @click="selType(2)"
      >
        <div class="exhibition-top">
          <div class="top-right">
            <div class="right-number number_two">
              {{ trainNumber.noStartCnt || "0" }}
            </div>
            <div class="right-title">待运输</div>
          </div>
        </div>
      </div>
      <div
        class="each-exhibition"
        :class="{ 'sel-exhibition': topType == 3 }"
        @click="selType(3)"
      >
        <div class="exhibition-top">
          <div class="top-right">
            <div class="right-number number_three">
              {{ trainNumber.onlineCnt || "0" }}
            </div>
            <div class="right-title">运输中</div>
          </div>
        </div>
      </div>
      <div
        class="each-exhibition"
        :class="{ 'sel-exhibition': topType == 4 }"
        @click="selType(4)"
      >
        <div class="exhibition-top">
          <div class="top-right">
            <div class="right-number number_four">
              {{ trainNumber.arriveCnt || "0" }}
            </div>
            <div class="right-title">已到达</div>
          </div>
        </div>
      </div>
      <div
        class="each-exhibition"
        :class="{ 'sel-exhibition': topType == 5 }"
        @click="selType(5)"
      >
        <div class="exhibition-top">
          <div class="top-right">
            <div class="right-number number_five">
              {{ trainNumber.abnormalCnt || "0" }}
            </div>
            <div class="right-title">超时</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 数据展示 -->
    <assemblyTable
      style="height: 730px"
      v-if="tableData.records && tableData.records.length"
      :tableData="tableData.records"
      @handleClick="handleClick"
    ></assemblyTable>

    <div v-else class="know_img">
      <img src="@/assets/arrival/empty.png" class="empty_img" alt="" />
    </div>
    <div class="paging">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :hide-on-single-page="
          !tableData ||
            !tableData.pageSize ||
            tableData.totalRow / tableData.pageSize <= 1
        "
        :current-page="currentPage"
        :page-count="Math.ceil(tableData.totalRow / tableData.pageSize)"
        :page-size="tableData.pageSize"
        layout="total, sizes, prev, pager, next"
        :total="tableData.totalRow"
      >
      </el-pagination>
    </div>

    <vxe-modal
      v-model="positionFlag"
      title="运单轨迹"
      width="88%"
      height="96%"
      resize
      remember
      @close="closePositionFunc"
    >
      <Position
        v-if="positionFlag"
        :key="timer"
        ref="positionRef"
        :order-code="selInfo.code"
        type="inTransit"
        @fatherSubmitMethod="fatherSubmitFunc"
        @fatherCancelMethod="fatherCancelFunc"
      />
    </vxe-modal>
  </div>
</template>

<script>
import assemblyTable from "./components/assemblyTable.vue";
// import screenfull from "screenfull"; //引入依赖
import timeTable from "@/api/estimate/timeTable";
// import md5 from "js-md5";
import "../../utils/directive";
import Position from "./components/Position.vue";
export default {
  components: {
    assemblyTable,
    Position
  },
  data() {
    return {
      selInfo: {},
      timer: "",
      code4OrderTrack: "",
      positionFlag: false,
      selSearchNum: 1,
      newTime: "",
      setTimeInterval: "",
      setTimeOut: "",
      workPoints: "", //工点
      transfer: "", //中转仓/消纳场
      fleet: "", //搜索车队/车辆查询
      transferList: [],
      currentPage: 1,
      // placeList: [], //地点集合
      // transferListStatus: false,
      locationStatus: false, //树组件状态
      treeList: [], //树组件选中集合
      transferSelectList: [],
      trainNumber: {
        abnormalCnt: 0,
        arriveCnt: 0,
        cnt: 0,
        noStartCnt: 0,
        onlineCnt: 0
      }, //车次统计
      tableData: {
        rows: [],
        totalRow: 0,
        pageSize: 0,
        pageNumber: 0,
        extraData: null,
        totalPage: 0,
        firstPage: true,
        lastPage: false
      }, //信息数组展示
      currentTime: new Date(),
      topType: 0 //点击统计按类别查询（1:今日总车次，2：在途车次，3：到达车次，4：异常车次）
      // pages:'small',                          //big 当前为大页面  small 当前为小页面
    };
  },
  created() {
    //初始化数据
    this.getInfo(); //获取数据信息
    // this.storehouse(); //获取消纳场工地地点
    // this.transferList = this.$store.state.user.storehouse_list;
    this.setTimeInterval = setInterval(() => {
      let date = new Date();
      var hours =
        date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      var minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      var seconds =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      this.newTime = hours + ":" + minutes + ":" + seconds;
    }, 1000);
  },
  mounted() {},
  beforeDestroy() {
    // 页面销毁前销毁setTimeOut
    clearTimeout(this.setTimeOut);
    clearInterval(this.setTimeInterval);
    // if (document.fullscreenElement) {
    //   //判断是否为全屏状态
    //   screenfull.toggle(); //退出全屏状态
    // }
  },
  filters: {
    getDate(e) {
      return (
        e.getFullYear() + "年" + (e.getMonth() + 1) + "月" + e.getDate() + "日"
      );
    },
    getWeeb(e) {
      switch (e.getDay()) {
        case 0:
          return "周日";
          break;
        case 1:
          return "周一";
          break;
        case 2:
          return "周二";
          break;
        case 3:
          return "周三";
          break;
        case 4:
          return "周四";
          break;
        case 5:
          return "周五";
          break;
        case 6:
          return "周六";
          break;

        default:
          break;
      }
    }
  },
  methods: {
    handleClick(e) {
      this.selInfo = e;
      this.positionFlag = true;
    },
    closePositionFunc() {
      this.$refs.positionRef.closeModal();
    },
    fatherCancelFunc(modelFlag) {
      switch (modelFlag) {
        case "cancelOrder":
          this.cancelOrderFlag = false;
          break;
        case "cancelAffirm":
          this.cancelAffirmFlag = false;
          break;
        case "sendOrder":
          this.sendOrderFlag = false;
          break;
        case "load":
          this.loadFlag = false;
          break;
        case "loadAffirm":
          this.loadAffirmFlag = false;
          break;
        case "reload":
          this.reloadFlag = false;
          break;
        case "unload":
          this.unloadFlag = false;
          break;
        case "unloadAffirm":
          this.unloadAffirmFlag = false;
          break;
        case "reunload":
          this.reunloadFlag = false;
          break;
        case "exchange":
          this.exchangeFlag = false;
          break;
        case "position":
          this.positionFlag = false;
          break;
        default:
      }
    },
    // ------------------
    fatherSubmitFunc(modelFlag) {
      switch (modelFlag) {
        case "cancelOrder":
          this.cancelOrderFlag = false;
          break;
        case "cancelAffirm":
          this.cancelAffirmFlag = false;
          break;
        case "sendOrder":
          this.sendOrderFlag = false;
          break;
        case "load":
          this.loadFlag = false;
          break;
        case "loadAffirm":
          this.loadAffirmFlag = false;
          break;
        case "reload":
          this.reloadFlag = false;
          break;
        case "unload":
          this.unloadFlag = false;
          break;
        case "unloadAffirm":
          this.unloadAffirmFlag = false;
          break;
        case "reunload":
          this.reunloadFlag = false;
          break;
        case "exchange":
          this.exchangeFlag = false;
          break;
        case "position":
          this.positionFlag = false;
          break;
        default:
      }
      this.findList();
    },
    selSearch(e) {
      // 天数切换
      this.selSearchNum = e;
      this.getInfo();
    },
    selType(type) {
      //1总车次 2待运输 3运输中 4运输中 5异常
      this.topType == type ? (this.topType = 0) : (this.topType = type);
      this.currentPage = 1;
      this.getInfo(); //获取数据
    },

    // 执行
    getInfo() {
      // 销毁未执行的延迟调用
      clearTimeout(this.setTimeOut);

      this.getStatistics(); //获取统计信息
      this.getinformation(); //获取列表信息
      // 一分钟后进行数据刷新
      this.setTimeOut = setTimeout(() => {
        this.getInfo();
      }, 60 * 1000);
    },

    //获取统计信息
    getStatistics() {
      // 初始化
      let params = {
        day: this.selSearchNum
      };
      timeTable
        .top(params)
        .then(res => {
          console.log("12", res);
          this.trainNumber = res.data;
          // this.placeList = res.data.workSiteList;
        })
        .catch(e => {
          // this.$message.error('请求超时,请刷新页面重试');
        });
    },
    getinformation() {
      // 初始化获取列表信息
      let params = {
        day: this.selSearchNum,
        pageNum: this.currentPage,
        pageSize: 10,
        topType: this.topType === 0 ? 1 : this.topType
      };
      timeTable
        .query(params)
        .then(res => {
          console.log("1231231", res);
          this.tableData = res.data;

          this.tableData.totalRow = res.data.total;
          this.tableData.pageSize = res.data.pageSize;
          this.tableData.pageNumber = res.data.pageNum;
          this.tableData.totalPage = res.data.totalPage;
        })
        .catch(e => {
          // this.$message.error('请求超时,请刷新页面重试');
        });
    },

    handleSizeChange(e) {
      console.log("11", e);
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.getInfo(); //获取数据
      console.log(e);
    }
    // pagesBig() {
    //   screenfull.toggle(); //全屏
    // },
    // handleFullScreen() {
    //   console.log(screenfull);
    //   screenfull.toggle();
    // },
  }
};
</script>

<style lang="scss">
.real-time-page {
  background-color: #091c2c;
  width: 100%;
  min-width: 1920px;
  height: 100vh;
  overflow: hidden;
  background-image: url("../../assets/arrival/img_bg_nor@2x.png");
  background-size: 100% 100%;

  .head {
    position: absolute;
    top: 0;
    left: 0;
    // min-width: 1920px;
    width: 100vw;
    height: 164px;
    display: flex;
    background-image: url("../../assets/arrival/pageTop.png");
    background-size: 100% 100%;
    .head-left {
      flex: 1;
      position: relative;
      // overflow: hidden;
      .left-img {
        width: 100%;
        height: 64px;
      }
      .time {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-size: 12px;
        color: rgba(240, 250, 255, 0.72);
        position: absolute;
        top: 53px;
        left: 27px;
        display: flex;
        align-items: center;
        .real_week {
          margin: 0 10px;
        }
        .real_time {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-size: 12px;
          color: rgba(203, 222, 237, 0.72);
        }
      }
    }
    .arrival_title {
      padding-top: 9px;
      box-sizing: border-box;
      font-family: YouSheBiaoTiHei, YouSheBiaoTiHei;
      font-weight: 400;
      font-size: 46px;
      color: #f4f8ff;
      line-height: 65px;
      letter-spacing: 2px;
    }
    .head-right {
      flex: 1;
      position: relative;
      overflow: hidden;
      .right_img {
        width: 100%;
        height: 64px;
      }

      .right-big {
        position: absolute;
        top: 49px;
        right: 20px;
        display: flex;
        flex-direction: row-reverse;
        align-items: center;
        font-size: 14px;
        color: #a8a9bb;
        .big-img {
          width: 15px;
          height: 15px;
          margin-right: 10px;
          margin-left: 12px;
          cursor: pointer;
        }
        .sel_time {
          margin-left: 23px;
          width: 80px;
          height: 36px;
          background-image: url(../../assets/arrival/rhombus.png);
          background-size: 100% 100%;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-size: 16px;
          color: #aaaaaa;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }
        .is_sel_time {
          background-image: url(../../assets/arrival/isRhombus.png);
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 500;
          font-size: 16px;
          color: #ffffff;
        }
      }
    }
  }
  .car-number {
    margin-top: 124px;
    padding: 0 72px;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    .each-exhibition {
      cursor: pointer;
      width: 349px;
      height: 174px;
      background-size: 100% 100%;
      .exhibition-top {
        padding: 47px 0 0 141px;
        box-sizing: border-box;
        .top-right {
          .right-title {
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 26px;
            color: #ffffff;
          }
          .right-number {
            font-family: zcool-gdh, zcool-gdh;
            font-weight: 400;
            font-size: 46px;
            line-height: 54px;
          }
          .number_one {
            background: linear-gradient(180deg, #f3fbff 0%, #8ad8ff 100%);
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
          .number_two {
            background: linear-gradient(180deg, #f3fbff 0%, #77fdd2 100%);
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
          .number_three {
            background: linear-gradient(180deg, #f3fbff 0%, #ffdc93 100%);
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
          .number_four {
            background: linear-gradient(180deg, #f3fbff 0%, #8ad8ff 100%);
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
          .number_five {
            background: linear-gradient(180deg, #f3fbff 0%, #ffa3a3 100%);
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
      }
      &:nth-child(1) {
        background-image: url("../../assets/arrival/bgNor1.png");
      }
      &:nth-child(2) {
        background-image: url("../../assets/arrival/bgNor2.png");
      }
      &:nth-child(3) {
        background-image: url("../../assets/arrival/bgNor3.png");
      }
      &:nth-child(4) {
        background-image: url("../../assets/arrival/bgNor4.png");
      }
      &:nth-child(5) {
        background-image: url("../../assets/arrival/bgNor5.png");
      }
    }

    .sel-exhibition {
      // 选中样式
      &:nth-child(1) {
        background-image: url("../../assets/arrival/bgNorSel1.png");
      }
      &:nth-child(2) {
        background-image: url("../../assets/arrival/bgNorSel2.png");
      }
      &:nth-child(3) {
        background-image: url("../../assets/arrival/bgNorSel3.png");
      }
      &:nth-child(4) {
        background-image: url("../../assets/arrival/bgNorSel4.png");
      }
      &:nth-child(5) {
        background-image: url("../../assets/arrival/bgNorSel5.png");
      }
    }
  }
  .paging {
    display: flex;
    flex-direction: row-reverse;
    margin-right: 20px;
    .el-pagination__total {
      color: rgba(255, 255, 255, 0.9);
    }
    .el-pager li {
      margin: 0 4px;
      background: rgba(81, 145, 225, 0.2);
      color: rgba(255, 255, 255, 0.9);
    }
    .el-pagination .btn-next,
    .el-pagination .btn-prev {
      background: rgba(81, 146, 225, 0);
      color: rgba(255, 255, 255, 0.9);
    }
    .el-pagination__jump {
      color: rgba(255, 255, 255, 0.9);
    }
    .el-pagination__editor.el-input .el-input__inner {
      background: rgba(81, 145, 225, 0.1);
      border: 0px;
      outline: none;
      color: rgba(255, 255, 255, 0.9);
    }
    .el-pager li.active {
      background: rgba(81, 145, 225, 0.2);
      border: 1px solid #5191e1;
      box-sizing: border-box;
      border-radius: 3px;
    }
    .el-pagination .el-select .el-input .el-input__inner {
      background: #18334f;
      border: 1px solid #18334f;
      color: #bde1e9;
    }
  }
  .know_img {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-size: 28px;
    color: #8b8b8b;
    padding-top: 15vh;
    .empty_img {
      width: 450px;
      height: 280px;
    }
  }
}
</style>

/* eslint-enable no-console */
